export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
    access_nivel: [1, 2, 3],
  },
  {
    title: 'Embarque de Equipes',
    route: 'team-boarding',
    icon: 'AnchorIcon',
    access_nivel: [1, 2, 3],
    ability: 'equipe.ver',
  },
  {
    title: 'Ocorrências',
    route: 'occurrences',
    icon: 'MapPinIcon',
    access_nivel: [1, 2, 3],
  },
  {
    title: 'Regulação',
    route: 'regulacao',
    icon: 'ActivityIcon',
    access_nivel: [1, 2, 3],
    ability: 'regulacao.ver',
  },
  {
    title: 'Despacho',
    route: 'despacho',
    icon: 'TruckIcon',
    access_nivel: [1, 2, 3],
    ability: 'despacho.ver',
  },
  {
    title: 'Retenções',
    route: 'list-retentions',
    icon: 'PackageIcon',
    access_nivel: [1],
  },
  {
    title: 'Profissionais',
    icon: 'UsersIcon',
    access_nivel: [1],
    children: [
      {
        title: 'Profissionais',
        route: 'list-professionals',
        access_nivel: [1],
      },
      {
        title: 'Tipos de Profissionais',
        route: 'list-professional-types',
        access_nivel: [1],
      },
      {
        title: 'Equipes',
        route: 'list-teams',
        access_nivel: [1],
      },
      {
        title: 'Tipos de Equipe',
        route: 'list-team-types',
        access_nivel: [1],
      },
      {
        title: 'Papéis',
        route: 'list-roles',
        access_nivel: [1],
        ability: 'rbac.gerenciar',
      },
    ],
  },
  {
    title: 'Cadastros',
    icon: 'FileTextIcon',
    access_nivel: [1],
    children: [
      {
        title: 'Áreas',
        route: 'list-areas',
        access_nivel: [1],
      },
      {
        title: 'CBOs',
        route: 'list-cbos',
        access_nivel: [1],
      },
      {
        title: 'Cidades',
        route: 'list-cities',
        access_nivel: [1],
      },
      {
        title: 'Classificações',
        route: 'list-classifications',
        access_nivel: [1],
      },
      {
        title: 'CIDs',
        route: 'list-cids',
        access_nivel: [1],
      },
      {
        title: 'Disciplinas',
        route: 'list-discipline',
        access_nivel: [1],
      },
      {
        title: 'Empresas',
        route: 'list-companies',
        access_nivel: [1],
      },
      {
        title: 'Equipamentos em uso',
        route: 'list-equipment-allocations',
        access_nivel: [1],
      },
      {
        title: 'Envolvidos',
        route: 'list-involveds',
        access_nivel: [1],
      },
      {
        title: 'Tipos de Acompanhantes',
        route: 'list-companion-types',
        access_nivel: [1],
      },
      {
        title: 'Estabelecimentos',
        route: 'list-establishments',
        access_nivel: [1],
      },
      {
        title: 'Tipos de Estabelecimentos',
        route: 'list-establishment-types',
        access_nivel: [1],
      },
      {
        title: 'Tipos de Rejeições',
        route: 'list-rejection-types',
        access_nivel: [1],
      },
      {
        title: 'Tipos de Veículos',
        route: 'list-vehicle-types',
        access_nivel: [1],
      },
      {
        title: 'UFs',
        route: 'list-ufs',
        access_nivel: [1],
      },
      {
        title: 'Usuários',
        route: 'list-users',
        access_nivel: [1],
        ability: 'usuario.gerenciar',
      },
      {
        title: 'Veículos',
        route: 'list-vehicles',
        access_nivel: [1],
      },
    ],
  },
  {
    title: 'Estrutura de Nós',
    icon: 'GitBranchIcon',
    access_nivel: [1],
    children: [
      {
        title: 'Tipos de Nós',
        route: 'list-node-types',
        access_nivel: [1],
        ability: 'node.admin',
      },
      {
        title: 'Nós',
        route: 'list-nodes',
        access_nivel: [1],
        ability: 'node.admin',
      },
    ],
  },
]
